import { EscalationTable } from "../../../Escalations/EscalationTable";

export function ContactEscalations() {
  return (
    <div>
      <EscalationTable context={ `contact` } />
    </div>
  );
}
